import { formatNumber } from '@local_modules/flokit'

export function valueFormatter (cellParams) {
  if (!cellParams.value) return null
  if (!Number.isFinite(cellParams.value)) return null

  if (cellParams.data.formatting?.type === 'percentage') {
    const decimals = cellParams.data.formatting?.decimals || 0
    const percentageValue = cellParams.value * 100
    return formatNumber(percentageValue, decimals) + '%'
  }

  const context = cellParams.context

  const decimals = Number.isFinite(context?.viewDecimals) ? context?.viewDecimals : 2
  return formatNumber(cellParams.value, decimals)
}
